module.exports = __webpack_public_path__ + "static/media/Gold_MLSA.70894cfa.jpeg";